export enum PlanType {
    Freemium = 'Freemium',
    Starter = 'Starter',
    Growth = 'Growth',
    Scale = 'Scale',
    Unlimited = 'Unlimited'
}